/**
 * Import frontend scripts
 */
const context = require.context('../../../packages/', true, /script\.js$/);

context.keys().forEach((key) => {
    try {
        context(key);
    } catch (err) {
        console.error(`Fehler beim Laden von ${key}:`, err);
    }
});